export default "__VITE_ASSET__D9v8oeht__"